<script setup lang="ts">
import UnAuthForm from '~/components/forms/contact/UnAuthForm.vue'
import AuthForm from '~/components/forms/contact/AuthForm.vue'
import TheLoader from '~/components/TheLoader.vue'
import type { ComputedRef } from 'vue'

import { useAuthStore } from '@/stores/auth'

const props = withDefaults(
  defineProps<{
    showForm?: 'unauth' | 'auth'
  }>(),
  {
    showForm: null,
  },
)

const forms = {
  auth: AuthForm,
  unauth: UnAuthForm,
} as object

const authStore = useAuthStore()

const loading = ref(true)

const Form = computed(() => {
  if (props.showForm) {
    return forms[props.showForm]
  }
  return forms[authStore.isAuthenticated ? 'auth' : 'unauth']
}) as ComputedRef<AuthForm | UnAuthForm>

onMounted(() => {
  loading.value = true
  setTimeout(() => {
    loading.value = false
  }, 1000)
})
</script>

<template>
  <div>
    <TheLoader v-if="loading" size="xlarge" />
    <component :is="Form" v-else />
  </div>
</template>
